import { Link, useLocation } from 'react-router-dom';

export default function MembershipTabs() {
  const location = useLocation();
  const isOnMembership = location.pathname === '/mi-membresia';
  const isOnFamily = location.pathname === '/plan-familiar';

  return (
    <ul className="flex gap-6 mb-6 text-sm font-medium font-juana">
      <li>
        <Link
          to="/mi-membresia"
          className={
            isOnMembership
              ? 'text-holos-dark border-b-2 border-holos-dark pb-1'
              : 'text-gray-600 hover:text-gray-800 cursor-pointer'
          }
        >
          Actualizar plan
          <span className="ml-2 inline-block bg-prosper/70 text-black text-xs font-semibold px-2 py-0.5 rounded-full border border-black">
            beta
          </span>
        </Link>
      </li>
      <li>
        <Link
          to="/plan-familiar"
          className={
            isOnFamily
              ? 'text-holos-dark border-b-2 border-holos-dark pb-1'
              : 'text-gray-600 hover:text-gray-800 cursor-pointer'
          }
        >
          Plan Familiar
          <span className="ml-2 inline-block bg-prosper/70 text-black text-xs font-semibold px-2 py-0.5 rounded-full border border-black">
            beta
          </span>
        </Link>
      </li>
    </ul>
  );
}
